import { render } from "./WidgetCompiled.vue?vue&type=template&id=635f6ad2"
import script from "./WidgetCompiled.vue?vue&type=script&lang=js"
export * from "./WidgetCompiled.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__